import { api } from '@/lib/api-client'
import type {
  AdminTrip,
  BookingChangeLogEntry,
  MessageResponse,
  PageResponse,
  RescheduleBookingRequest,
  TripFilters,
} from '@/types/api'

export function fetchTrips(filters: TripFilters): Promise<PageResponse<AdminTrip>> {
  return api.get<PageResponse<AdminTrip>>('/api/admin/trips', { query: { ...filters } })
}

export function fetchTrip(id: number): Promise<AdminTrip> {
  return api.get<AdminTrip>(`/api/admin/trips/${id}`)
}

export function modifyTripDriver(tripId: number, driverId: number): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/trips/${tripId}/modify/${driverId}`)
}

/**
 * Moves a trip's scheduled start, end, or both.
 *
 * Times are operational (Cairo) wall-clock values: "2026-08-05T14:30:00".
 *
 * This replaces the pair of `modify-start-time` / `modify-end-time` calls the
 * drawer used to make. Two calls could half-apply — the start saved, the end
 * refused — and neither touched the booking behind the trip, which is the row
 * the backend bills extra hours against. One call moves both records together
 * and records who moved them.
 */
export function rescheduleTrip(tripId: number, change: RescheduleBookingRequest): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/trips/${tripId}/schedule`, change)
}

/** Every operator change to this trip's booking, newest first. */
export function fetchTripChangeLog(tripId: number): Promise<BookingChangeLogEntry[]> {
  return api.get<BookingChangeLogEntry[]>(`/api/admin/trips/${tripId}/change-log`)
}

/**
 * The acting administrator is taken from the bearer token server-side; no user
 * id is sent from the browser.
 */
export function startTrip(tripId: number): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/trips/${tripId}/start-trip`)
}

export function endTrip(tripId: number): Promise<MessageResponse> {
  return api.patch<MessageResponse>(`/api/admin/trips/${tripId}/end-trip`)
}
